"use strict";

module.exports = {
  DONE: 'DONE',
  DRAFT: 'DRAFT',
  PENDING_UPLOADS: 'PENDING_UPLOADS',
  READY_FOR_REVIEW: 'READY_FOR_REVIEW',
  SENT_TO_RP: 'SENT_TO_RP'
};